import(/* webpackMode: "eager", webpackExports: ["SynetudesSVG"] */ "/home/harmo/projects/Synetudes/src/components/feedback/synetudes-svg.tsx");
